import { z } from "zod";
import { buildPassioRequestHeaders } from "./passioLocaleFromApp";
const REFRESH_BUFFER_MS = 60_000;
/** Passio `/oauth/token` response. */
const PassioTokenResponseSchema = z.object({
    access_token: z.string().optional(),
    customer_id: z.string().optional(),
    expires_in: z.number().optional(),
});
const tokenCacheByApiKey = new Map();
const inFlightTokenRequestByApiKey = new Map();
export const getPassioAuth = async (apiKey) => {
    if (!apiKey) {
        throw new Error("Passio API key is not configured");
    }
    const now = Date.now();
    const cachedToken = tokenCacheByApiKey.get(apiKey);
    if (cachedToken && cachedToken.expiresAtMs > now + REFRESH_BUFFER_MS) {
        return {
            accessToken: cachedToken.accessToken,
            customerId: cachedToken.customerId,
            expiresAtMs: cachedToken.expiresAtMs,
        };
    }
    let inFlightTokenRequest = inFlightTokenRequestByApiKey.get(apiKey);
    if (!inFlightTokenRequest) {
        inFlightTokenRequest = (async () => {
            const response = await fetch(`${process.env.PASSIO_TOKEN_URL}/${encodeURIComponent(apiKey)}`, { method: "POST" });
            if (!response.ok) {
                throw new Error(`Passio token request failed (${response.status})`);
            }
            const parsed = PassioTokenResponseSchema.safeParse(await response.json());
            const data = parsed.success ? parsed.data : {};
            if (!data.access_token || !data.customer_id) {
                throw new Error("Passio token response missing access_token or customer_id");
            }
            const expiresInSeconds = typeof data.expires_in === "number" ? data.expires_in : 86_400;
            const token = {
                accessToken: data.access_token,
                customerId: data.customer_id,
                expiresAtMs: Date.now() + expiresInSeconds * 1000,
            };
            tokenCacheByApiKey.set(apiKey, token);
            return token;
        })();
        inFlightTokenRequestByApiKey.set(apiKey, inFlightTokenRequest);
    }
    try {
        const token = await inFlightTokenRequest;
        return { accessToken: token.accessToken, customerId: token.customerId, expiresAtMs: token.expiresAtMs };
    }
    finally {
        if (inFlightTokenRequestByApiKey.get(apiKey) === inFlightTokenRequest) {
            inFlightTokenRequestByApiKey.delete(apiKey);
        }
    }
};
export const fetchPassioFoodByRefCode = async (apiKey, refCode, localization) => {
    const auth = await getPassioAuth(apiKey);
    const headers = buildPassioRequestHeaders(auth, localization);
    const url = `${process.env.PASSIO_PRODUCTS_BASE}/napi/food/search/result/refCode/${encodeURIComponent(refCode)}`;
    const response = await fetch(url, { headers });
    if (!response.ok) {
        throw new Error(`Passio food detail request failed (${response.status})`);
    }
    return response.json();
};
/** Clears cached token (for tests). */
export const resetPassioTokenCacheForTests = () => {
    tokenCacheByApiKey.clear();
    inFlightTokenRequestByApiKey.clear();
};
//# sourceMappingURL=passioApiClient.js.map